import { Grid } from '@mui/material';
import React from 'react';
import { ShowCountsCard } from '.';

function Component() {
  const dataArray = [
    {
      count: 12,
      title: 'Total Cards',
      link: '#abs',
      linkText: 'Visit',
    },
    {
      count: 6,
      title: 'Templates',
      link: '#abs',
      linkText: 'Visit',
    },
    {
      count: 24,
      title: 'Active Cards',
      link: '#abs',
      linkText: 'Visit',
    },
    {
      count: 8,
      title: 'Available Cards',
      link: '#abs',
      linkText: 'Visit',
    },
  ];
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <div className="text-2xl">Overview</div>
      </Grid>
      {dataArray.map((item, index) => {
        return (
          <Grid item key={index} lg={3} md={4} sm={6} xs={12}>
            <ShowCountsCard
              title={item.title}
              count={item.count}
              link={item.link}
              linkText={item.linkText}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default Component;
